import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'

import { isNilEmpty } from 'Utils'
import { paramsToTags } from 'Utils/searchFilterUtils'
import { urlSearchParamsToObj } from 'Utils/routerUtils'

import { areaParamList, classTypeToAreaParam } from 'Defaults/map'


const TagManager = (
  {
    render,
    initTagManager,
    lastSearch,
    updateSelectedFiltersList,
    metaLookup,
    tagLookups,
    tagLookupsFetching,
    unitSystemIsImperial,
    lookups,
    showOtherFilterTags,
    lookupFetching,
  }) => {
  const [state, updateState] = useState({
    areaFilterTags: null,
    otherFilterTags: null,
    lookupFilterTag: null,
  })
  const [lastSearchState, updateLastSearchState] = useState(lastSearch)
  const updateTags = () => {
    const lastSearchObj = urlSearchParamsToObj(lastSearch)
    // area filter tags except lookup area tag
    const areaFilterTags = paramsToTags({
      metaLookup,
      tagLookups,
      unitSystemIsImperial,
      lookups,
      excludeLookupArea: true,
      lastSearchObj: lastSearchObj ? R.pick(areaParamList, lastSearchObj) : {},
    })

    const lookupFilterTag = lookups.classType ? (
      paramsToTags({
        metaLookup,
        tagLookups,
        unitSystemIsImperial,
        lookups,
        lastSearchObj: {
          [`${classTypeToAreaParam[lookups.classType]}`]: String(lookups.id),
        },
      })
    ) : state.lookupFilterTag
    // all the search filters other than lookup and area
    const otherFilterTags = paramsToTags({
      metaLookup,
      tagLookups,
      unitSystemIsImperial,
      lookups,
      lastSearchObj: R.omit(areaParamList, lastSearchObj),
    })
    if(updateSelectedFiltersList) {
      updateSelectedFiltersList({
        areaFilterTags,
        otherFilterTags,
        lookupFilterTag,
      })
    }

    return {
      areaFilterTags,
      otherFilterTags,
      lookupFilterTag,
    }
  }
  useEffect(() => {
    if(lookups.classType) {
      const params = urlSearchParamsToObj(lastSearch)
      initTagManager(params)
    }
  }, [lookups])
  useEffect(() => {
    updateLastSearchState(lastSearch)
  }, [lastSearch])

  // useEffect(() => {
  //   updateState({
  //     ...state,
  //     // lookupAreaTag: null,
  //   })
  // }, [lookups, lastSearch])
  useEffect(() => {
    if(!tagLookupsFetching && lastSearchState !== lastSearch && metaLookup) {
      // need to get lookup area
      const params = urlSearchParamsToObj(lastSearch)
      initTagManager(params)
      updateState({
        ...updateTags(),
      })
    }
  }, [
    tagLookupsFetching,
    metaLookup,
    lastSearch,
    lastSearchState,
  ])
  useEffect(() => {
    if(!lookupFetching && tagLookups) {
      const searchFilters = updateTags()
      if(!isNilEmpty(searchFilters.lookupFilterTag)) {
        searchFilters.lookupFilterTag = searchFilters.lookupFilterTag.reduce((acc, selectedFilter) => {
          const key = `${selectedFilter.filter_type}_${selectedFilter.filter_value}`
          if(tagLookups[key]) {
            acc.push(tagLookups[key])
          } else {
            acc.push(selectedFilter)
          }
          return acc
        }, [])
      }
      if(!showOtherFilterTags && !isNilEmpty(searchFilters.areaFilterTags)) {
        searchFilters.areaFilterTags = searchFilters.areaFilterTags.reduce((acc, selectedFilter) => {
          const key = `${selectedFilter.filter_type}_${selectedFilter.filter_value}`
          if(tagLookups[key]) {
            acc.push(tagLookups[key])
          } else {
            acc.push(selectedFilter)
          }
          return acc
        }, [])
      }
      updateState(searchFilters)
      if(updateSelectedFiltersList) {
        updateSelectedFiltersList(searchFilters)
      }
    } else {
      updateState({
        ...state,
        // lookupAreaTag: null,
      })
      // updateLookupAreaFilter(null)
    }
  }, [tagLookups, lookupFetching])

  return render ? render(state) : ''
}

export default TagManager

TagManager.propTypes = {
  lastSearch: PropTypes.string.isRequired,
  initTagManager: PropTypes.func,
  render: PropTypes.func,
  updateSelectedFiltersList: PropTypes.func,
  lastSearchObj: PropTypes.shape({}),
  metaLookup: PropTypes.shape({}),
  /**
   * It contains area data from algolia area index
   * later this data will be used to update areaFilterTags, lookupFilterTag data if data contains
   * lookupRequired true
   */
  tagLookups: PropTypes.shape({}),
  tagLookupsFetching: PropTypes.bool,
  // eslint-disable-next-line
  unitSystemIsImperial: PropTypes.bool,
  lookups: PropTypes.shape({
    id: PropTypes.number,
    classType: PropTypes.string,
  }),
  updateLookupAreaFilter: PropTypes.func,
  // isFilterSearchOpen: PropTypes.bool,
  /**
   * Other tags such as listing price, bed will be shown
   * This boolean value is mainly for the save search and update save search
   *
   */
  showOtherFilterTags: PropTypes.bool,
}
